module.exports = __webpack_public_path__ + "img/resp-ecommerce.83b02d45.svg";